import React from 'react'
import { Box, Typography, Grid2 as Grid, CircularProgress } from '@mui/material'
import { useEditTemplate } from './EditTemplateContext'
import Paper from 'components/@extended/Paper'
import TemplateComponentsSection from './TemplateComponentsSection'

const TemplateComponents: React.FC = () => {
  const { allocationTables, validationResult, isLoading } = useEditTemplate()

  return (
    <Paper elevation={2} sx={{ p: 3, minWidth: '1050px', maxWidth: '1100px' }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h5">Allocations</Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                px: 2,
                border: '1px dashed',
                borderColor: validationResult.isValid ? 'success.main' : 'divider',
                borderRadius: 1,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Allocation Valid: {validationResult.isValid ? '✅' : '❌'}
              </Typography>
              {!validationResult.isValid && (
                <Typography variant="body2" color="text.secondary">
                  — {validationResult.message}
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12 }}>
          {isLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Loading allocation tables...</Typography>
            </Box>
          ) : allocationTables.length <= 0 ? (
            <Typography>No Allocation Tables Yet</Typography>
          ) : (
            <TemplateComponentsSection />
          )}
        </Grid>
      </Grid>
    </Paper>
  )
}

export default TemplateComponents
